import React from 'react';
import './successPage.css';
import successAnimation from '../../assets/lottie/success.json';
import Lottie from 'lottie-react';

const SuccessPage = () => {
    return (
        <div className="success-container">
            <div className="success-card">
                <Lottie animationData={successAnimation} loop={false} className="success-animation" />
                <h1 className="success-title">Payment Successful!</h1>
                <p className="success-message">
                    Thank you for your purchase. Your order has been successfully processed.
                </p>
                <button className="success-button" onClick={() => (window.location.href = '/')}>
                    Continue Shopping
                </button>
            </div>
        </div>
    );
};

export default SuccessPage;